import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../Layout';
import MainWrapper from './MainWrapper';
import UserAuthentication from './UserAuthentication';
import BulkWordDeletePage from '../../shared/components/words/BulkWordDeletePage';
import BulkWordModifyPage from '../../shared/components/words/BulkWordModifyPage';

const ConnectionLogs = React.lazy(() => import('../ConnectionLog'));
const SuspicionLogs = React.lazy(() => import('../SuspicionLog'));
const ReportLogs = React.lazy(() => import('../ReportLog'));
const KoreanWords = React.lazy(() => import('../KoreanWords'));
const EnglishWords = React.lazy(() => import('../EnglishWords'));
const KoreanWordEdit = React.lazy(() => import('../KoreanWords/components/WordEdit'));
const EnglishWordEdit = React.lazy(() => import('../EnglishWords/components/WordEdit'));
const KoreanWordAudits = React.lazy(() => import('../KoreanWordAudits'));
const EnglishWordAudits = React.lazy(() => import('../EnglishWordAudits'));
const Users = React.lazy(() => import('../Users'));
const UserAudits = React.lazy(() => import('../UserAudits'));
const Mailbox = React.lazy(() => import('../Mailbox'));
const MailboxAudits = React.lazy(() => import('../MailboxAudits'));
const Events = React.lazy(() => import('../Events'));
const EventAudits = React.lazy(() => import('../EventAudits'));
const Shop = React.lazy(() => import('../Shop'));
const ShopAudits = React.lazy(() => import('../ShopAudits'));
const Crosswords = React.lazy(() => import('../Crosswords'));
const ThemePresets = React.lazy(() => import('../ThemePresets'));
const WordSpellcheck = React.lazy(() => import('../WordSpellcheck'));
const OAuthClients = React.lazy(() => import('../OAuthClients'));
const AdminAccess = React.lazy(() => import('../AdminAccess'));
const ServerManagement = React.lazy(() => import('../ServerManagement'));
const ApiDocs = React.lazy(() => import('../ApiDocs'));

export function AdminRoutes() {
  return (
    <div>
      <Layout />
      <div className="container__wrap">
        <React.Suspense fallback={<h1>Please wait...</h1>}>
          <Routes>
            <Route path="/connection-logs" element={<ConnectionLogs />} />
            <Route path="/suspicion-logs" element={<SuspicionLogs />} />
            <Route path="/report-logs" element={<ReportLogs />} />
            <Route path="/users" element={<Users />} />
            <Route path="/user-audits" element={<UserAudits />} />
            <Route path="/mailbox" element={<Mailbox />} />
            <Route path="/mailbox-audits" element={<MailboxAudits />} />
            <Route path="/events" element={<Events />} />
            <Route path="/event-audits" element={<EventAudits />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop-audits" element={<ShopAudits />} />
            <Route path="/words-ko" element={<KoreanWords />} />
            <Route path="/words-ko/bulk-delete" element={<BulkWordDeletePage lang="ko" languageName="한국어" />} />
            <Route path="/words-ko/bulk-modify" element={<BulkWordModifyPage lang="ko" languageName="한국어" />} />
            <Route path="/words-ko/:type/:id?" element={<KoreanWordEdit />} />
            <Route path="/words-en" element={<EnglishWords />} />
            <Route path="/words-en/bulk-delete" element={<BulkWordDeletePage lang="en" languageName="영어" />} />
            <Route path="/words-en/bulk-modify" element={<BulkWordModifyPage lang="en" languageName="영어" />} />
            <Route path="/words-en/:type/:id?" element={<EnglishWordEdit />} />
            <Route path="/word-audits-ko" element={<KoreanWordAudits />} />
            <Route path="/word-audits-en" element={<EnglishWordAudits />} />
            <Route path="/crosswords" element={<Crosswords />} />
            <Route path="/theme-presets" element={<ThemePresets />} />
            <Route path="/word-spellcheck" element={<WordSpellcheck />} />
            <Route path="/oauth-clients" element={<OAuthClients />} />
            <Route path="/admin-access" element={<AdminAccess />} />
            <Route path="/server-management" element={<ServerManagement />} />
            <Route path="/api-docs" element={<ApiDocs />} />
          </Routes>
        </React.Suspense>
      </div>
    </div>
  );
}

export default function AdminRouter() {
  return (
    <MainWrapper>
      <main>
        <UserAuthentication>
          <AdminRoutes />
        </UserAuthentication>
      </main>
    </MainWrapper>
  );
}
